<template>
  <!-- 对话框 -->
  <transition name="hehe">
    <p v-show="show">
      <i class="el-icon-success" v-if="type_msg == 'success'" style="color: rgb(0, 128, 6);"></i>
      <i class="el-icon-warning" v-else style="color: rgb(236, 59, 28);"></i>
      {{ text_data }}

    </p>
  </transition>

</template>

<script>
  var _this;

  export default {

    props: {
      'isShow': Boolean,
      'data': '',
      'type_data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.text_data = _this.data;

        _this.type_msg = _this.type_data;

        setTimeout(() => {
          _this.show = false;
        }, 1500);

      },
    },
    data() {
      return {


        show: false,

        text_data: '',

        type_msg: ''

      };
    },
    created() {

      _this = this;

    },
    methods: {




      closeDialog() {

        _this.show = false;

        _this.text_data = '';

        _this.type_msg = '';

      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  .hehe-enter,
  .hehe-leave-to {
    opacity: 0;
  }

  .hehe-enter-to,
  .hehe-leave {
    opacity: 1;
  }

  .hehe-enter-active,
  .hehe-leave-active {
    transition: all .5s;
  }

  p {
    /* width: auto; */
    /* padding: 40px; */
    padding: 0 50px;
    box-sizing: border-box;
    font-size: 30px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, .8);
    box-shadow: 5px 5px 10px rgb(168, 168, 168);
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999999;
    transform: translate(-50%, -50%);
    text-align: center;
  }
</style>